export default __webpack_public_path__ + "static/media/5 raw.c4f739a2.mp3";